export const solutions = {
  catering: [
    {
      img: 'customize',
      title: '자유로운 커스터마이징',
      description:
        '프랜차이즈처럼 키오스크를 꾸미고 싶다면, 자유로운 커스텀이 가능한 우노스 요식업 프로그램을 이용해 보세요. 우리 매장 특색에 맞는 이미지와 동영상을 넣거나 우노스에서 제공하는 다양한 컬러 프리셋으로 키오스크를 꾸밀 수 있습니다.',
    },
    {
      img: 'management',
      title: '언제 어디서나 매장관리',
      description:
        '키오스크-포스는 실시간 연동되어 매출과 메뉴관리를 간편히 해결할 수 있으며, 키오스크-포스와 연동되는 매장관리 프로그램은 PC와 모바일로 이용이 가능하여 언제 어디서든 쉽고 빠르게 사용할 수 있습니다.',
    },
    {
      img: 'call',
      title: '다양한 호출방법',
      description:
        '대형 매장을 쉽게 관리할 수 있는 카카오 알림 톡은 별도의 송수신 장비가 필요 없어 간편합니다. 고객님은 휴대폰으로 호출 알림을 받을 수 있으며, 알림 하단에 카카오톡 채널 추가 기능을 넣어 고객님께 알람을 보낼 수 있는 마케팅 용도로 활용할 수 있습니다. \n 카카오 알림톡 이외에도 모니터 번호 호출, 진동벨, 테이블 번호 등 다양한 호출 솔루션을 보유하고있습니다.',
    },
    {
      img: 'point',
      title: '간편한 포인트 / 스탬프 적립',
      description:
        '별도의 태블릿이나 포인트 적립 안내를 할 필요 없이, 우키키 멤버십 서비스로 모든 걸 해결할 수 있습니다. 고객님께서 결제 이후 포인트 / 스탬프 적립을 위한 팝업이 자동으로 노출되며, 번호 입력으로 간편하게 포인트 / 스탬프 적립이 가능합니다.',
    },
  ],
  spicy_hot_pot: [
    {
      img: 'scale',
      title: '편리한 저울 연동',
      description:
        '우노스 마라탕 프로그램은 저울과 연동되어 점주님이 설정해 놓은 수치에 따라 자동으로 가격을 계산해 줍니다.',
    },
    {
      img: 'management',
      title: '언제 어디서나 매장관리',
      description:
        '키오스크-포스는 실시간 연동되어 매출과 메뉴관리를 간편히 해결할 수 있으며, 키오스크-포스와 연동되는 매장관리 프로그램은 PC와 모바일로 이용이 가능하여 언제 어디서든 쉽고 빠르게 사용할 수 있습니다.',
    },
    {
      img: 'call',
      title: '다양한 호출방법',
      description:
        '대형 매장을 쉽게 관리할 수 있는 카카오 알림 톡은 별도의 송수신 장비가 필요 없어 간편합니다. 고객님은 휴대폰으로 호출 알림을 받을 수 있으며, 알림 하단에 카카오톡 채널 추가 기능을 넣어 고객님께 알람을 보낼 수 있는 마케팅 용도로 활용할 수 있습니다. 카카오 알림톡 이외에도 모니터 번호 호출, 진동벨, 테이블 번호 등 다양한 호출 솔루션을 보유하고있습니다.',
    },
  ],
  unmanned: [
    {
      img: 'unmanned',
      title: '완전 무인 매장',
      description:
        '우노스 프로그램을 이용하여 24시간 이용 가능한 완전 무인 매장을 운영할 수 있습니다. 점주님은 상품 바코드를 스캔하여 상품 등록 및 관리가 가능하며, 손님은 점주님이 뽑아서 붙인 상품 바코드로 직접 스캔하여 키오스크로 구매가 가능합니다.',
    },
    {
      img: 'management',
      title: '언제 어디서나 매장관리',
      description:
        '키오스크-포스는 실시간 연동되어 매출과 메뉴관리를 간편히 해결할 수 있으며, 키오스크-포스와 연동되는 매장관리 프로그램은 PC와 모바일로 이용이 가능하여 언제 어디서든 쉽고 빠르게 사용할 수 있습니다.',
    },
    {
      img: 'point',
      title: '간편한 포인트 / 스탬프 적립',
      description:
        '별도의 태블릿이나 포인트 적립 안내를 할 필요 없이, 우키키 멤버십 서비스로 모든 걸 해결할 수 있습니다. 고객님께서 결제 이후 포인트 / 스탬프 적립을 위한 팝업이 자동으로 노출되며, 번호 입력으로 간편하게 포인트 / 스탬프 적립이 가능합니다.',
    },
  ],
};

export const uses = {
  catering: [
    {
      img: 'discount',
      title: '시간대별 메뉴 할인',
      description:
        '런치세트를 12:00 ~ 14:00 까지만 할인하여 키오스크에 노출할 수 있어요!',
    },
    {
      img: 'mobile_order',
      title: '모바일 오더',
      description:
        '바쁜 출퇴근 시간 아메리카노를 우키키 애플리케이션으로 주문하여 빠르게 받을 수 있었습니다.',
    },
    {
      img: 'subscription',
      title: '선불카드 발행',
      description:
        '5만원 선불카드를 판매하고 있습니다. \n 현금처럼 이용할 수 있고, 1개월 동안 전체 금액의 5% 할인을 무제한으로 받을 수 있습니다.',
    },
  ],
  spicy_hot_pot: [
    {
      img: 'minmax',
      title: '최소,최종 금액 설정',
      description:
        '매장 운영 방법에 따라 자유롭게 금액 계산 방법을 정할 수 있어 매장 운영에 도움이 되었습니다.',
    },
    {
      img: 'side',
      title: '사이드 메뉴 매출 증가',
      description:
        '마진율이 높은 사이드 메뉴를 키오스크에 노출하여 매출이 증가했어요!',
    },
  ],
};
